/** When your routing table is too long, you can split it into small modules**/


export default [
  {
    path: '/payments',
    name: 'userpayments',
    component: () => import('@/views/enduser/Payments'),
  },
  {
    path: '/reserve',
    name: 'userreserve',
    component: () => import('@/views/enduser/Reserve'),
  },
  {
    path: '/orders',
    name: 'userorders',
    component: () => import('@/views/enduser/Orders'),
  },
  


]

